var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.0001H14.0059M19.8334 14.0001H19.8392M8.16671 14.0001H8.17254M6.06671 8.16675H21.9334C23.2402 8.16675 23.8936 8.16675 24.3927 8.42107C24.8317 8.64477 25.1887 9.00173 25.4124 9.44077C25.6667 9.9399 25.6667 10.5933 25.6667 11.9001V16.1001C25.6667 17.4069 25.6667 18.0603 25.4124 18.5594C25.1887 18.9984 24.8317 19.3554 24.3927 19.5791C23.8936 19.8334 23.2402 19.8334 21.9334 19.8334H6.06671C4.75992 19.8334 4.10652 19.8334 3.6074 19.5791C3.16835 19.3554 2.8114 18.9984 2.58769 18.5594C2.33337 18.0603 2.33337 17.4069 2.33337 16.1001V11.9001C2.33337 10.5933 2.33337 9.9399 2.58769 9.44077C2.8114 9.00173 3.16835 8.64477 3.6074 8.42107C4.10652 8.16675 4.75992 8.16675 6.06671 8.16675ZM14.2917 14.0001C14.2917 14.1612 14.1611 14.2917 14 14.2917C13.839 14.2917 13.7084 14.1612 13.7084 14.0001C13.7084 13.839 13.839 13.7084 14 13.7084C14.1611 13.7084 14.2917 13.839 14.2917 14.0001ZM20.125 14.0001C20.125 14.1612 19.9945 14.2917 19.8334 14.2917C19.6723 14.2917 19.5417 14.1612 19.5417 14.0001C19.5417 13.839 19.6723 13.7084 19.8334 13.7084C19.9945 13.7084 20.125 13.839 20.125 14.0001ZM8.45837 14.0001C8.45837 14.1612 8.32779 14.2917 8.16671 14.2917C8.00562 14.2917 7.87504 14.1612 7.87504 14.0001C7.87504 13.839 8.00562 13.7084 8.16671 13.7084C8.32779 13.7084 8.45837 13.839 8.45837 14.0001Z",
    stroke: "#414651",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetPassword);
export default __webpack_public_path__ + "static/media/setPassword.8f9d7c16efca184a311210048e3808e9.svg";
export { ForwardRef as ReactComponent };